import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Animated,
  ActivityIndicator,
} from "react-native";
import FilterBar from "app/components/FilterBar";
import Text from "app/components/Text";
import Value from "app/components/Value";
import Canvas from "app/components/Canvas";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import prefActions from "app/utils/prefActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import filterHelpers from "app/utils/filterHelpers";
import { Ionicons } from "@expo/vector-icons";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  WIDTH,
  HEIGHT,
  CHILD_RATIO,
  PARENT_RATIO,
} from "app/utils/styleSheet";
import Hoverable from "app/components/Hoverable";

import TimelineNodes from "app/components/TimelineNodes";
import Generation from "app/components/Generation";

import store from "app/redux/store";
import { index } from "app/actions/values";
import { setLoading, setUpdatedAt } from "app/actions/app";

export default class Focus extends React.Component {
  static navigationOptions = ({
    navigation,
    navigationOptions,
    screenProps,
  }) => {
    return { headerShown: false };
  };

  constructor(props) {
    super(props);
    let { app, preferences, values } = store.getState();
    values = filterHelpers.apply(values);
    this.state = {
      values,
      loading: app.loading,
      localLoading: app.localLoading,
      familyIds: [],
      selectedValue: null,
      query: "",
      quickActionsId: null,
      preferences,
      expandAnim: new Animated.Value(0),
      animating: false,
    };
    this.SIZE = 110;
  }

  setHeaderButton = () => {
    let { navigation, route } = this.props;
    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons
            name="ios-menu"
            size={32}
            color={colors.foreground}
            style={{ marginRight: 20 }}
          />
        </TouchableOpacity>
      ),
    });
  };

  async componentDidMount() {
    this.setHeaderButton();

    store.subscribe(() => {
      console.log("updating Focusfrom store");
      let { values, app, preferences } = store.getState();
      let { loading, localLoading } = app;
      values = filterHelpers.apply(values);
      this.setState({
        values,
        loading,
        localLoading,
        preferences,
      });
    });
  }

  render() {
    let {
      values,
      preferences,
      loading,
      localLoading,
      query,
      selectedValue,
      familyIds,
      quickActionsId,
      showFocus,
    } = this.state;

    let timelineWidthAnim = this.state.expandAnim.interpolate({
      inputRange: [0, 100],
      outputRange: [150, WIDTH],
    });
    let generationTreeHeightAnim = this.state.expandAnim.interpolate({
      inputRange: [0, 100],
      // outputRange: [0, HEIGHT]
      outputRange: ["-100%", "0%"],
    });

    return (
      <View style={styles.container} ref={(ref) => (this.wrapperRef = ref)}>
        <StatusBar style="auto" />

        <FilterBar temporary filters={filterHelpers.defaultFocusFilters()} />

        <View style={{ flex: 1 }}>
          {localLoading ? (
            <ActivityIndicator size="large" color={colors.foreground} />
          ) : (
            this.renderValues(timelineWidthAnim, generationTreeHeightAnim)
          )}
        </View>

        <View />
      </View>
    );
  }

  renderValues = (timelineWidthAnim, generationTreeHeightAnim) => {
    let {
      values,
      query,
      familyIds,
      selectedValue,
      quickActionsId,
      showFocus,
      animating,
      preferences,
    } = this.state;

    let focusValues = values.filter((v) => {
      if (!!query?.length) {
        if (v.text.toLowerCase().includes(query.toLowerCase())) {
          return true;
        }
      }
      return preferences.focusIds.includes(v.id);
    });

    let levelScaling = 1;
    let scalePerc = 1;
    let levelScale = 1;
    let maxSize = this.SIZE * levelScale;
    let minSize = this.SIZE * 0.9 * levelScale;
    let size = maxSize;
    let minWrapperSize = ENV.WEB ? maxSize * 1.25 : maxSize * 1.1;
    let gutterSize = (size / 2) * screenRatio * 0.2 * 3;
    let outterSize = size + gutterSize;
    let maxOutterSize = outterSize;
    if (!ENV.WEB) maxOutterSize = size;

    return (
      <ScrollView
        ref={(ref) => (this.scrollerRef = ref)}
        contentContainerStyle={{ flexGrow: 1 }}
        // style={{borderWidth: 5, borderColor: 'green'}}
      >
        {this.renderBackdrop()}

        {
          <View
            style={[
              styles.row,
              { width: "100%" },
              animating && { overflow: "hidden" },
              // {borderWidth: 2, borderColor: 'green',},
            ]}
          >
            {this.renderBackdrop()}
            {focusValues.map((value, i) => {
              if (selectedValue?.id == value.id) {
                return (
                  <Animated.View
                    key={i}
                    style={[
                      styles.row,
                      {
                        justifyContent: "center",
                        alignItems: "flex-end",
                        zIndex: 1,
                      },
                      { position: "absolute", bottom: 0 },
                      { bottom: generationTreeHeightAnim },
                    ]}
                  >
                    {this.renderBackdrop()}
                    {valueHelpers.getParents({ value }).map((parent, j) => {
                      return (
                        <Generation
                          key={j}
                          value={parent}
                          size={this.SIZE * PARENT_RATIO}
                          // setValueRef={(ref, key) => { this[key] = ref }}
                          nextGen={valueHelpers.getParents({ value: parent })}
                          genKey={"parents"}
                          level={1}
                          navigation={this.props.navigation}
                          // onUpdate={this.handleUpdate}
                          // onPress={bulkSelectIds?.length ? this.toggleBulkSelection : undefined}
                          // focusIds={bulkSelectIds}
                          showFocusRing
                          // onDragEnd={this.handleDragEnd}
                          // style={{maxWidth: WIDTH/value.parents.length}}
                          scaleFactor={0}
                        />
                      );
                    })}
                  </Animated.View>
                );
              } else
                return (
                  <View
                    key={i}
                    style={[
                      styles.row,
                      {
                        minWidth: this.SIZE,
                        // borderWidth: 1,
                      },
                    ]}
                  >
                    {this.renderBackdrop()}
                  </View>
                );
            })}
          </View>
        }

        <View
          style={[
            styles.row,
            // {minHeight: maxSize},
            { flexGrow: 0.1 },
            // {borderWidth: 5, borderColor: 'white',},
          ]}
        >
          {this.renderBackdrop()}
          <TouchableWithoutFeedback
            onPress={() => {
              this.hoverOut();
              this.setState({ quickActionsId: null });
            }}
            accessible={false}
          >
            <ScrollView
              horizontal
              contentContainerStyle={[
                styles.rowScrollerContent,
                // {borderWidth: 2, borderColor: 'red'},
                {
                  // alignSelf: 'center',
                  minHeight: 300,
                  flex: 1,
                  justifyContent: "center",
                },
              ]}
            >
              {focusValues.map((value, i) => {
                let selected = selectedValue?.id == value.id;
                let selectedFamily = familyIds.includes(value.id);
                return (
                  <Animated.View
                    key={i}
                    style={[
                      { maxWidth: selected ? timelineWidthAnim : 150 },
                      animating && { overflow: "hidden" },
                      selected && { zIndex: 2 },
                    ]}
                  >
                    {/*!!selected && (
                      <View style={[styles.row, {justifyContent: 'center', alignItems: 'flex-end'}]}> 
                        {value.parents.map(val => (
                          <Generation
                            value={val}
                            // setValueRef={(ref, key) => { this[key] = ref }}
                            nextGen={val.parents || values.filter(v => val.parent_ids?.includes(v.id)) || []}
                            genKey={'parents'}
                            level={1}
                            navigation={navigation}
                            onUpdate={this.handleUpdate}
                            // onPress={bulkSelectIds?.length ? this.toggleBulkSelection : undefined}
                            // focusIds={bulkSelectIds}
                            showFocusRing
                            // onDragEnd={this.handleDragEnd}
                            date={date}
                          />
                        ))}
                      </View>
                    )*/}

                    <Hoverable accessible={false}>
                      {(isHovered) => {
                        let isFtuePrompt =
                          typeof value.id == "string" &&
                          value.id.includes("ftue");
                        let baseSize = size;

                        if (isHovered) {
                          let scaleFactor = Math.max(1.1, this.SIZE / size);
                          scalePerc = scaleFactor;
                        } else {
                          scalePerc = 1;
                        }

                        return (
                          <TouchableWithoutFeedback
                            onPress={() => {
                              this.hoverOut();
                              this.setState({ quickActionsId: null });
                            }}
                            accessible={false}
                          >
                            <View
                              style={[
                                styles.valueWrapper,
                                {
                                  minWidth: minWrapperSize,
                                  minHeight: size * 1.4,
                                  transform: [{ scale: scalePerc }],
                                  opacity: !selectedValue || selected ? 1 : 0.2,
                                },
                              ]}
                            >
                              <Value
                                size={size}
                                value={value}
                                key={`value-${value.id}`}
                                ref={(ref) => {
                                  this[`val_${value.id}`] = ref;
                                }}
                                selected={selected}
                                onDeselect={() => this.hoverOut(value)}
                                // onLongPress={isFtuePrompt || (value.id == 1 && demoStep < 3) ? () => null : undefined}
                                onPress={() => {
                                  if (!!quickActionsId) {
                                    this.setState({ quickActionsId: null });
                                  } else if (selected) {
                                    RootNavigation.navigate("Value", {
                                      id: value.id,
                                    });
                                  } else if (selectedFamily) {
                                    this.hoverIn(value);
                                  }
                                  // else if(!!selectedValue){
                                  //   this.hoverOut()
                                  // }
                                  else {
                                    this.hoverIn(value);
                                  }
                                }}
                                style={[]}
                                maxWidth={250}
                                // filterToFamily={() => this.handleFilterToFamily(value)}
                                // onUpdate={val => this.handleUpdate(val)}
                                // showQuickActions={quickActionsId == value.id}
                                // onShowQuickActions={() => this.setState({quickActionsId: value.id})}
                                // onHideQuickActions={() => this.setState({quickActionsId: null})}
                                onSelect={
                                  ENV.WEB
                                    ? () => this.hoverIn(value)
                                    : undefined
                                }
                                // hiddenIds={this.state.hiddenIds}
                                // todoIds={this.state.todoIds}
                                // focusIds={this.state.focusIds}
                                showFocusRing={!!showFocus}
                                // date={date}
                              />
                            </View>
                          </TouchableWithoutFeedback>
                        );
                      }}
                    </Hoverable>

                    {!!selected && (
                      <View style={{ zIndex: 2 }}>
                        <TimelineNodes
                          size={this.SIZE * CHILD_RATIO}
                          value={value}
                          // onProgress={(...props) => this.saveCheck(...props, value)}
                          // onCreateChild={(...props) => this.createChild(...props, value)}
                          // onUpdate={this.handleUpdate}
                          // deleteDoneAt={(...props) => this.deleteDoneAt(...props, value)}
                          onDragStart={() =>
                            this.setState({ isDragging: true })
                          }
                          onDragEnd={this.handleDragEnd}
                          // wrapperStyle={{...styles.row, alignSelf: 'center'}}
                          shelfThreshold={this.state.shelfThreshold}
                          onShelf={this.handleShelf}
                        />
                      </View>
                    )}
                  </Animated.View>
                );
              })}
            </ScrollView>
          </TouchableWithoutFeedback>
        </View>

        {
          <View
            style={[
              styles.row,
              { width: "100%" },
              animating && { overflow: "hidden" },
              // {borderWidth: 2, borderColor: 'green',},
            ]}
          >
            {this.renderBackdrop()}
            {focusValues.map((value, i) => {
              if (selectedValue?.id == value.id) {
                return (
                  <Animated.View
                    key={i}
                    style={[
                      styles.row,
                      {
                        justifyContent: "center",
                        alignItems: "flex-start",
                        zIndex: 1,
                      },
                      { position: "absolute", top: 0 },
                      { top: generationTreeHeightAnim },
                    ]}
                  >
                    {this.renderBackdrop()}
                    {/*valueHelpers.getChildren({value}).map((child,j) => {
                    let val = values.find(v => v.id == child.id) || child
                    return (
                      <Generation
                        key={j}
                        value={val}
                        // setValueRef={(ref, key) => { this[key] = ref }}
                        nextGen={val.children || values.filter(v => val.child_ids?.includes(v.id)) || []}
                        genKey={'children'}
                        level={0}
                        navigation={navigation}
                        onUpdate={this.handleUpdate}
                        // onPress={bulkSelectIds?.length ? this.toggleBulkSelection : undefined}
                        // focusIds={bulkSelectIds}
                        showFocusRing
                        // onDragEnd={this.handleDragEnd}
                        // style={{maxWidth: WIDTH/value.children.length}}
                        scaleFactor={0}
                        date={date}
                      />
                    )
                  })*/}
                  </Animated.View>
                );
              } else
                return (
                  <View
                    key={i}
                    style={[
                      styles.row,
                      { justifyContent: "center", alignItems: "flex-end" },
                    ]}
                  >
                    {this.renderBackdrop()}
                  </View>
                );
            })}
          </View>
        }
        {/*<View 
          style={[styles.row, 
            {borderWidth: 2, borderColor: 'green',},
          ]} 
        >
          {!!selectedValue && (
            <View style={[styles.row, {justifyContent: 'center', alignItems: 'flex-end'}]}> 
              <TimelineNodes 
                value={selectedValue} 
                onProgress={this.saveCheck} 
                onUpdate={this.handleUpdate}
                deleteDoneAt={this.deleteDoneAt}
                onDragStart={() => this.setState({isDragging: true})}
                onDragEnd={this.handleDragEnd}
                // wrapperStyle={{...styles.row, alignSelf: 'center'}}
                shelfThreshold={this.state.shelfThreshold}
                onShelf={this.handleShelf}
              />
            </View>
          )}
        </View>*/}
      </ScrollView>
    );
  };

  renderBackdrop = () => {
    return (
      <TouchableWithoutFeedback
        accessible={false}
        onPress={() => {
          this.hoverOut();
          this.setState({ quickActionsId: null });
        }}
      >
        <View
          style={{
            ...StyleSheet.absoluteFillObject,
            // bottom: -100,
            // opacity: 0,
            zIndex: -1,
            // borderWidth: 5, borderColor: 'blue',
          }}
        />
      </TouchableWithoutFeedback>
    );
  };

  // updateValuesToRender = (values=null) => {
  //   if(values==null) values = this.state.values
  //   let valuesToRender = valueHelpers.onlyRecentRevisions(values)
  //   if(this.filterBar) valuesToRender = this.filterBar.applyFilters(valuesToRender)
  //   // valuesToRender = valueHelpers.sortByTimeline(valuesToRender)
  //   this.setState({valuesToRender})
  // }

  // handleUpdate = async (val, newPrefs=null) => {
  //   let { values } = this.state
  //   if(values.find(v => v.id == val.id)){
  //     values = this.state.values.map(v => v.id == val.id ? {...v, ...val} : v)
  //   } else {
  //     values.push(val)
  //   }

  //   values = valueHelpers.sortByTimeline(values)
  //   storageActions.saveItem('values', values)
  //   // values = valueHelpers.onlyRecentRevisions(values)
  //   // if(this.filterBar) values = this.filterBar.applyFilters(values)
  //   // values = valueHelpers.sortByTimeline(values)
  //   this.updateValuesToRender(values)
  //   // values = valueHelpers.applyLevels(values)

  //   console.log('handleupdate:', val, newPrefs)
  //   // if(!!newPrefs){
  //   //   this.setState({...newPrefs})
  //   // }
  //   let pref = await prefActions.get(true)
  //   await this.setState({
  //     // values,
  //     query: '',
  //     hiddenIds: pref.hidden_ids,
  //     todoIds: pref.todo_ids,
  //     focusIds: pref.focus_ids,
  //     // filters: pref.filters,
  //   })
  //   await this.setState({values})
  // }

  // saveCheck = async (progressAt=null, note=null, onComplete=null, value) => {
  //   // let { newProgressAt, value, newNote, } = this.state
  //   let timestamp = progressAt
  //   let updatedVal = await valueActions.createProgress(value, timestamp, note, false)
  //   console.log(updatedVal.timeline)
  //   value = {...value, timeline: updatedVal.timeline}
  //   this.handleUpdate(value)
  //   onComplete && onComplete(value)
  // }

  // createChild = async (created_at, text, valueData={}, onComplete=null, value) => {
  //   let data = {
  //     created_at,
  //     text,
  //     parent_ids: [value.id],
  //     ...valueData,
  //   }
  //   let child = await valueActions.create(data)
  //   if(!!child){
  //     this.handleUpdate(child)
  //     value.children.push(child)
  //     value.child_ids.push(child.id)
  //     this.handleUpdate(value)
  //     onComplete && onComplete(value)
  //   }
  // }

  // deleteDoneAt = async (date, value) => {
  //   let event = value.timeline.find(event => event.timestamp == date && event.type == 'progress')
  //   let note = event.note
  //   let removeIndex = value.progress_at.indexOf(date)
  //   console.log(event)

  //   // reindexing notes is troublesome, so only allow the most recent progress to be deleted
  //   if(removeIndex != 0){
  //     alert('Only the most recent event can be deleted')
  //     return
  //   }

  //   if(event.type != 'progress'){
  //     alert('Cannot delete special events')
  //     return
  //   }

  //   let extraWarning = !!note ? ' Associated note will be deleted as well.' : ''
  //   let confirm = await valueActions.confirm('delete', '', `Delete event?${extraWarning}`)
  //   if(!confirm) return

  //   value.progress_at.splice(removeIndex, 1)
  //   if(!!note){
  //     let noteIndex = value.notes.indexOf(note)
  //     value.notes.splice(noteIndex, 1)
  //   }
  //   let updatedVal = await apiActions.request(`values/${value.id}`, 'PATCH', {value})
  //   if(!!updatedVal){
  //     value = {...value, timeline: updatedVal.timeline}
  //     // value = valueHelpers.applyColorsFromFamily(value)
  //     this.handleUpdate(value)
  //     valueActions.updateValues(value)
  //   }
  // }

  // handleFilterToFamily= (value) => {
  //   let fam = [value]

  //   let children = values.filter(v => v.parent_ids && v.parent_ids.includes(value.id))
  //   fam = [...fam, ...children]

  //   let grandchildren = values.filter(v =>
  //     children.filter(c => !!c.child_ids && c.child_ids?.includes(v.id)).length > 0
  //     &&
  //     fam.filter(f => f.id == v.id).length == 0
  //   )
  //   fam = [...fam, ...grandchildren]

  //   let parents = values.filter(v => !!v.child_ids && v.child_ids?.includes(value.id) && fam.filter(f => f.id == v.id).length == 0)
  //   fam = [...fam, ...parents]

  //   let grandparents = values.filter(v =>
  //     parents.filter(p => p.parent_ids && p.parent_ids.includes(v.id)).length > 0
  //     &&
  //     fam.filter(f => f.id == v.id).length == 0
  //   )
  //   fam = [...fam, ...grandparents]

  //   this.setState({values: fam})
  // }

  hoverIn = async (value) => {
    console.log(value);
    // let { values } = this.state
    // let familyIds = [value.id]
    let lines = [];

    let family = valueHelpers.getFamily(value);
    let familyIds = family.map((v) => v.id);

    // let parentIds = value.parent_ids
    // while(parentIds.length){
    //   familyIds = [...familyIds, ...parentIds]
    //   let parents = values.filter(v => parentIds.includes(v.id))
    //   parentIds = parents.map(v => v.parent_ids).flat()
    // }

    // let childIds = valueHelpers.getChildren({value}).map(c => c.id)
    // while(childIds.length){
    //   familyIds = [...familyIds, ...childIds]
    //   let children = values.filter(v => childIds.includes(v.id))
    //   childIds = children.map(v => v.child_ids).flat()
    // }

    // familyIds = [...new Set(familyIds)]
    await this.setState({
      familyIds,
      lines,
      selectedValue: value,
      quickActionsId: null,
    });
    // this.updateValuesToRender()

    await this.setState({ animating: true });
    this.state.expandAnim.setValue(0);
    Animated.timing(this.state.expandAnim, {
      // toValue: WIDTH,
      toValue: 100,
      duration: 400,
      // easing: Easing.in(Easing.quad),
    }).start(() => {
      this.setState({ animating: false });
    });
  };

  hoverOut = async (value = null) => {
    await this.setState({
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
    });
    // this.updateValuesToRender()
    this.state.expandAnim.setValue(0);
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
    // backgroundColor: '#111',
  },
  row: {
    flexGrow: 1,
    // flex: 1,
    borderColor: colors.trim,
    // borderBottomWidth: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    // padding: sizes.large,
    // borderColor:'white',borderWidth:1,
  },
  rowScroller: {
    flex: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    flexWrap: "nowrap",
  },
  rowScrollerContainer: {
    flexGrow: 1,
    flexDirection: "row",
    justifyContent: "center",
    // alignItems: 'center',
    alignItems: "stretch",
    // paddingTop: sizes.base,
    // flexWrap: 'wrap',
  },
  rowScrollerContent: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "flex-start",
  },
  valueWrapper: {
    // flex: 1,
    // alignSelf: 'stretch',
    // flexGrow: 0,
    justifyContent: "center",
    alignItems: "center",
  },
  queryRow: {
    flexGrow: 0,
    height: 50,
    padding: sizes.base,
    justifyContent: "flex-start",
  },
  input: {
    ...styleSheet.input,
    alignSelf: "stretch",
    flex: 1,
  },
  icon: {
    marginLeft: sizes.base,
    minWidth: sizes.base,
    minHeight: sizes.base,
    // borderWidth: 1, borderColor: 'white',
  },
});
